<template>
    <v-card class="transparent d-flex flex-column" width="100%" height="100%" flat tile depressed>
        <v-card class="transparent theme-title d-flex align-center justify-center selector-text" height="100px" flat tile>Kezdőjátékosok kijelölése</v-card>
        <v-card class="transparent d-flex flex-nowrap selector-upper" :class="isMirrored ? 'flex-row-reverse' : ''" width="100%" flat tile depressed>
            <v-card class="transparent d-flex flex-column text-center align-center justify-center" width="50%" height="100%" flat tile depressed>
                <v-card class="transparent selector-team d-flex align-center theme-title" flat tile depressed>
                    {{teams['A'].name}}
                </v-card>
                <v-card class="transparent selector-players theme-text" flat tile depressed :style="teams['A'].maxPlayers === teams['A'].active ? 'color: #23C373 !important;' : ''">
                    {{teams['A'].maxPlayers}} / {{teams['A'].active}} játékos
                </v-card>
            </v-card>
            <v-card class="transparent d-flex flex-column text-center align-center justify-center" width="50%" height="100%" flat tile depressed>
                <v-card class="transparent selector-team d-flex align-center theme-title" flat tile depressed>
                    {{teams['B'].name}}
                </v-card>
                <v-card class="transparent selector-players theme-text" flat tile depressed :style="teams['B'].maxPlayers === teams['B'].active ? 'color: #23C373 !important;' : ''">
                    {{teams['B'].maxPlayers}} / {{teams['B'].active}} játékos
                </v-card>
            </v-card>
        </v-card>
        <v-card class="transparent d-flex align-center justify-center" width="100%" height="100px" flat tile depressed>
            <v-btn class="selector-btn theme-highborder" :disabled="(teams['A'].maxPlayers !== teams['A'].active) || (teams['B'].maxPlayers !== teams['B'].active)" color="#23C373" depressed tile @click="playersSelected">Kész</v-btn>
        </v-card>
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    export default {
        name: 'PlayerSelect',
        props: {
            teams: Object,
            isMirrored: Boolean,
        },
        methods: {
            playersSelected() {
                eventBus.$emit(CONSTANTS.EVENTS.MATCH.START);
            }
        },
    }
</script>

<style>
    .selector-upper {
        height: calc(100% - 200px);
    }

    .selector-team {
        font-size: 20px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        line-height: 22px;
        height: 44px;
    }

    .selector-players {
        font-size: 14px;
        line-height: 26px;
        height: 26px;
    }

    .selector-text {
        font-size: 24px;
        font-weight: bold;
        line-height: 26px;
    }

    .selector-btn {
        width: 150px;
        border-style: solid;
        border-width: 1px;
        height: 40px !important;
    }
</style>
